import { render, staticRenderFns } from "./FileForm20.vue?vue&type=template&id=b3765126&scoped=true&"
import script from "./FileForm20.vue?vue&type=script&lang=js&"
export * from "./FileForm20.vue?vue&type=script&lang=js&"
import style0 from "./FileForm20.vue?vue&type=style&index=0&id=b3765126&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3765126",
  null
  
)

export default component.exports